export default config => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  return config;
};



// WEBPACK FOOTER //
// ./templates/floor/assets/js/Global/AjaxInterceptors/Request/common.js